/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {

  
const comingSoonData = JSON.parse(
  document.getElementById("variant-comingsoon-data").textContent
);

document.addEventListener("theme:variant:change", function (event) {
    const variant = event.detail.variant;
    if (!variant) return;

    // 1) Produktweit Coming Soon?
    const productComingSoon = window.productComingSoon === true;

    // 2) Variantenbezogen Coming Soon?
    const entry = comingSoonData.find(v => v.id == variant.id);
    const variantComingSoon = entry?.comingsoon == 1;

    // 3) Gesamtzustand
    const comingSoon = productComingSoon || variantComingSoon;

    const atcBtn = document.querySelector(".product__submit__add");
    const countdown = document.querySelector(".variant__countdown");
    const comingSoonBtn = document.querySelector(".comingsoon-btn");

    if (comingSoon) {
        atcBtn?.style && (atcBtn.style.display = "none");
        countdown?.style && (countdown.style.display = "none");
        comingSoonBtn?.style && (comingSoonBtn.style.display = "block");
        return;
    }

    atcBtn?.style && (atcBtn.style.display = "block");
    countdown?.style && (countdown.style.display = "block");
    comingSoonBtn?.style && (comingSoonBtn.style.display = "none");
});








  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
